module.exports = __webpack_public_path__ + "static/media/edit.604beb98.svg";